import { FormFieldData } from './types';

export const MEDICATION_FORM_FIELD_DATA: FormFieldData[] = [
  {
    id: 'name',
    name: 'name',
    label: 'Medication Name',
    placeholder: 'Add medication name',
    buttonName: 'Continue',
    inputType: 'text',
    iconName: 'Injection',
    required: true,
  },
  {
    id: 'dosage',
    name: 'dosage',
    label: 'Medication Dosage',
    placeholder: 'Write the medication dosage',
    buttonName: 'Continue',
    inputType: 'text',
    iconName: 'Injection',
    required: true,
  },
  {
    id: 'frequency',
    name: 'frequency',
    label: 'Medication Frequency',
    placeholder: 'Select Frequency',
    buttonName: 'Continue',
    inputType: 'select',
    iconName: 'Injection',
    required: true,
    options: [
      { label: 'As needed', value: 'As needed' },
      { label: 'Every day', value: 'Every day' },
      { label: 'Every other day', value: 'Every other day' },
      { label: 'Every 2 days', value: 'Every 2 days' },
      { label: 'Every 3 days', value: 'Every 3 days' },
      { label: 'Every 4 days', value: 'Every 4 days' },
      { label: 'Every 5 days', value: 'Every 5 days' },
      { label: 'Every 6 days', value: 'Every 6 days' },
      { label: 'Once a week', value: 'Once a week' },
    ],
    subComponent: [
      {
        id: 'reminder',
        name: 'reminder',
        label: 'Reminder',
        placeholder: '',
        inputType: 'switch',
      },
    ],
  },
  {
    id: 'endDate',
    name: 'medicationEndDate',
    label: 'Medication end date (optional)',
    placeholder: 'Select the end date',
    buttonName: 'Continue',
    inputType: 'date',
    iconName: 'Injection',
    required: false,
  },
  {
    id: 'details',
    name: 'details',
    label: 'Any additional details?',
    placeholder: 'Write details here',
    buttonName: 'Continue',
    inputType: 'text',
    iconName: 'Injection',
    required: false,
  },
  {
    id: 'preview',
    name: '',
    label: 'Your medication details',
    placeholder: '',
    buttonName: 'Save Medication',
    inputType: 'preview',
    iconName: 'Injection',
    required: false,
  },
];

export const MEDICATION_DETAILS_FIELDS: Record<string, string> = {
  name: 'name',
  dosage: 'dosage',
  frequency: 'frequency',
  reminder: 'reminder',
  end_date: 'endDate',
  instruction: 'details',
};
